import { render, staticRenderFns } from "./VRegister.vue?vue&type=template&id=4d183338&"
import script from "./VRegister.vue?vue&type=script&lang=js&"
export * from "./VRegister.vue?vue&type=script&lang=js&"
import style0 from "./VRegister.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports